import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-visits',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class VisitsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
